
document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.tab-btn');
  const termsSection = document.querySelector('.terms-section');

  tabButtons.forEach((tab) => {
    tab.addEventListener('click', () => tabClicked(tab));
  });

  function tabClicked(tab) {
    // Remove 'active' class from all tabs
    tabButtons.forEach(tab => {
      tab.classList.remove('active');
    });
    // Add 'active' class to the clicked tab
    tab.classList.add('active');

    // Remove 'active' class from all contents
    const contents = document.querySelectorAll('.content');
    contents.forEach((content) => {
      content.classList.remove('active');
    });

    // Add 'active' class to the selected content
    const contentId = tab.getAttribute('content-id');
    const contentSelected = document.getElementById(contentId);
    contentSelected.classList.add('active');

    // Use the same measured landing behavior as the other section links.
    if (termsSection) window.StellarSectionJump?.to(termsSection);
  }
});